import { useQuery } from '@tanstack/react-query';
import { ChevronRight } from 'lucide-react';

import {
    SidebarContent,
    SidebarFooter,
    SidebarGroup,
    SidebarGroupContent,
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
} from '@nesso/ui/primitives/sidebar';

import { sessionsByDayOptions } from '@/entities/session';
import { useSheetStore } from '@/shared/stores/sheet-store';

import { TodaySessionsItem } from './today-sessions-content/today-sessions-item';
import { TodaySessionsItemSkeleton } from './today-sessions-content/today-sessions-item-skeleton';

export function TodaySessionsContent() {
    const { data: sessions = [], isPending: isLoading } = useQuery(sessionsByDayOptions());
    const openSheet = useSheetStore((state) => state.openSheet);
    return (
        <>
            <SidebarContent className="flex-1 min-h-0">
                <SidebarGroup>
                    <SidebarGroupContent>
                        <SidebarMenu>
                            {isLoading ? (
                                Array.from({ length: 3 }).map((_, idx) => (
                                    <TodaySessionsItemSkeleton key={idx} />
                                ))
                            ) : sessions.length > 0 ? (
                                sessions.map((session) => {
                                    return <TodaySessionsItem key={session.id} session={session} />;
                                })
                            ) : (
                                <SidebarMenuItem className="px-4 py-6">
                                    No session notes yet
                                </SidebarMenuItem>
                            )}
                        </SidebarMenu>
                    </SidebarGroupContent>
                </SidebarGroup>
            </SidebarContent>

            <SidebarFooter className="p-0">
                <SidebarMenu>
                    <SidebarMenuItem className="py-4 px-2">
                        <SidebarMenuButton
                            className="justify-between px-2"
                            onClick={() => {
                                openSheet({ type: 'sessions/past', label: 'Past Sessions' });
                            }}
                        >
                            All Past Sessions
                            <ChevronRight className="h-4 w-4" />
                        </SidebarMenuButton>
                    </SidebarMenuItem>
                </SidebarMenu>
            </SidebarFooter>
        </>
    );
}
